export var uk;
(function (uk) {
    uk.names = {
        AU: "Австралія",
        AT: "Австрія",
        AZ: "Азербайджан",
        AX: "Аландські острови",
        AL: "Албанія",
        DZ: "Алжир",
        AS: "Американське Самоа",
        AI: "Ангілья",
        AO: "Ангола",
        AD: "Андорра",
        AQ: "Антарктида",
        AG: "Антигуа і Барбуда",
        MO: "Аоминь",
        AR: "Аргентина",
        AM: "Арменія",
        AW: "Аруба",
        AF: "Афганістан",
        BS: "Багами",
        BD: "Бангладеш",
        BB: "Барбадос",
        BH: "Бахрейн",
        BZ: "Беліз",
        BE: "Бельгія",
        BJ: "Бенін",
        BM: "Бермуди",
        BY: "Білорусь",
        BG: "Болгарія",
        BO: "Болівія",
        BA: "Боснія і Герцеговина",
        BW: "Ботсвана",
        BR: "Бразилія",
        IO: "Британська Територія в Індійському Океані",
        VG: "Британські Віргінські Острови",
        BN: "Бруней Даруссалам",
        BF: "Буркіна-Фасо",
        BI: "Бурунді",
        BT: "Бутан",
        VU: "Вануату",
        VA: "Ватикан",
        GB: "Великобританія",
        VE: "Венесуела",
        VI: "Віргінські Острови (США)",
        WF: "Волліс і Футуна",
        VN: "В'єтнам",
        UM: "Зовнішні малі острови (США)",
        GA: "Габон",
        HT: "Гаїті",
        GY: "Гаяна",
        GM: "Гамбія",
        GH: "Гана",
        GP: "Гваделупа",
        GT: "Гватемала",
        GF: "Гвіана",
        GN: "Гвінея",
        GW: "Гвінея-Бісау",
        GG: "Гернсі",
        GI: "Гібралтар",
        HN: "Гондурас",
        HK: "Гонконг",
        GD: "Гренада",
        GR: "Греція",
        GE: "Грузія",
        GU: "Гуам",
        GL: "Ґренландія",
        DK: "Данія",
        JE: "Джерсі",
        DJ: "Джибуті",
        DM: "Домініка",
        DO: "Домініканська Республіка",
        CD: "Демократична Республіка Конго",
        EC: "Еквадор",
        GQ: "Екваторіальна Гвінея",
        ER: "Еритрея",
        EE: "Естонія",
        ET: "Ефіопія",
        EG: "Єгипет",
        YE: "Ємен",
        ZM: "Замбія",
        ZW: "Зімбабве",
        IL: "Ізраїль",
        IN: "Індія",
        ID: "Індонезія",
        IQ: "Ірак",
        IR: "Іран",
        IE: "Ірландія",
        IS: "Ісландія",
        ES: "Іспанія",
        IT: "Італія",
        JO: "Йорданія",
        CV: "Кабо-Верде",
        KZ: "Казахстан",
        KY: "Кайманові Острови",
        KH: "Камбоджа",
        CM: "Камерун",
        CA: "Канада",
        BQ: "Карибські Нідерланди",
        QA: "Катар",
        KE: "Кенія",
        CY: "Кіпр",
        KI: "Кірибаті",
        KG: "Киргизстан",
        TW: "Республіка Китай",
        KP: "КНДР (Корейська Народно-Демократична Республіка)",
        CN: "КНР (Китайська Народна Республіка)",
        CC: "Кокосові острови",
        CO: "Колумбія",
        KM: "Коморські Острови",
        XK: "Косово",
        CR: "Коста-Рика",
        CI: "Кот-д'Івуар",
        CU: "Куба",
        KW: "Кувейт",
        CW: "Кюрасао",
        LA: "Лаос",
        LV: "Латвія",
        LS: "Лесото",
        LR: "Ліберія",
        LB: "Ліван",
        LY: "Лівія",
        LT: "Литва",
        LI: "Ліхтенштейн",
        LU: "Люксембург",
        MU: "Маврикій",
        MR: "Мавританія",
        MG: "Мадагаскар",
        YT: "Майотта",
        MK: "Македонія",
        MW: "Малаві",
        MY: "Малайзія",
        ML: "Малі",
        MV: "Мальдівы",
        MT: "Мальта",
        MA: "Марокко",
        MQ: "Мартиніка",
        MH: "Маршаллові Острови",
        MX: "Мексика",
        FM: "Мікронезія",
        MZ: "Мозамбік",
        MD: "Молдова",
        MC: "Монако",
        MN: "Монголія",
        MS: "Монтсеррат",
        MM: "М'янма",
        NA: "Намібія",
        NR: "Науру",
        NP: "Непал",
        NE: "Нігер",
        NG: "Нігерія",
        NL: "Нідерланди",
        NI: "Нікарагуа",
        DE: "Німеччина",
        NU: "Ніуе",
        NZ: "Нова Зеландія",
        NC: "Нова Каледонія",
        NO: "Норвегія",
        AE: "Об'єднані Арабські Емірати",
        OM: "Оман",
        BV: "Острів Буве",
        HM: "Острів Герд і острови Макдональд",
        IM: "Острів Мен",
        NF: "Острів Норфолк",
        CX: "Острів Різдва",
        CK: "Острови Кука",
        SH: "Острови Святої Єлени, Вознесіння і Тристан-да-Кунья",
        TC: "Острови Теркс і Кайкос",
        PK: "Пакистан",
        PW: "Палау",
        PS: "Палестинська держава",
        PA: "Панама",
        PG: "Папуа Нова Гвінея",
        ZA: "ПАР",
        PY: "Парагвай",
        PE: "Перу",
        GS: "Південна Джорджія та Південні Сандвічеві Острови",
        KR: "Південна Корея",
        SS: "Південний Судан",
        MP: "Північні Маріанські Острови",
        PN: "Піткерн",
        PL: "Польша",
        PT: "Португалія",
        PR: "Пуерто-Ріко",
        CG: "Республіка Конго",
        RE: "Реюньйон",
        RU: "Росія",
        RW: "Руанда",
        RO: "Румунія",
        EH: "САДР",
        SV: "Сальвадор",
        WS: "Самоа",
        SM: "Сан-Маріно",
        ST: "Сан-Томе і Принсіпі",
        SA: "Саудівська Аравія",
        SZ: "Свазіленд",
        SJ: "Свальбард і Ян-Маєн",
        SC: "Сейшельські Острови",
        BL: "Сен-Бартельмі",
        MF: "Сен-Мартен",
        PM: "Сен-П'єр і Мікелон",
        SN: "Сенегал",
        VC: "Сент-Вінсент і Гренадини",
        KN: "Сент-Кіттс і Невіс",
        LC: "Сент-Люсія",
        RS: "Сербія",
        SG: "Сінгапур",
        SX: "Сінт-Мартен",
        SY: "Сірія",
        SK: "Словаччина",
        SI: "Словенія",
        SB: "Соломонові Острови",
        SO: "Сомалі",
        SD: "Судан",
        SR: "Суринам",
        TL: "Східний Тимор",
        US: "США",
        SL: "Сьєрра-Леоне",
        TJ: "Таджикистан",
        TH: "Таїланд",
        TZ: "Танзанія",
        TG: "Того",
        TK: "Токелау",
        TO: "Тонга",
        TT: "Тринідад і Тобаго",
        TV: "Тувалу",
        TN: "Туніс",
        TM: "Туркменістан",
        TR: "Турція",
        UG: "Уганда",
        HU: "Угорщина",
        UZ: "Узбекистан",
        UA: "Україна",
        UY: "Уругвай",
        FO: "Фарерські острови",
        FJ: "Фіджі",
        PH: "Філіппіни",
        FI: "Фінляндія",
        FK: "Фолклендські Острови",
        FR: "Франція",
        PF: "Французька Полінезія",
        TF: "Французькі Південні і Антарктичні Території",
        HR: "Хорватія",
        CF: "Центральноафриканська Республіка",
        TD: "Чад",
        ME: "Чорногорія",
        CZ: "Чехія",
        CL: "Чілі",
        CH: "Швейцарія",
        SE: "Швеція",
        LK: "Шрі-Ланка",
        JM: "Ямайка",
        JP: "Японі",
    };
})(uk || (uk = {}));
//# sourceMappingURL=uk.js.map